import gql from 'graphql-tag';

export const GET_PROPOSAL_PRODUCTS = gql`
  query ProposalProducts($input: ProposalProductsInput) {
    proposalProducts(input: $input) {
      proposalProductId
      title
      cost
      markup {
        markup
        type
      }
      retailCost
      thirdPartyUrl
      createdDateTime
      modifiedDateTime
      aftermarketProduct {
        aftermarketProductId
        aftermarketVendorApiChannel
        productIsNoLongerAvailable
        criteria
        externalId
        productCategory
        productDescriptionExternal
        productDescriptionInternal
        productName
        productType
        createdDateTime
        modifiedDateTime
        productLogoUrl
        sourceOfCreation
        config {
          criteriaValues
        }
        aftermarketProductCatalogDetails {
          productSummary
          limitationsOfLiability
          eligibilityAndInclusions
          legalDisclaimer
          paragraphDescription
          coverageDetails
        }
        partnerLinks {
          name
          partnerLinkId
          partnerProfile {
            name
          }
        }
        documents {
          documentId
          docName
          source
        }
      }
    }
  }
`;
